let Constants = {
	PROMO_CODE: "639",
	CH_PROMO: "CH_639_MLB_WEB_CARTACEA22_BIS_CRS_20220103_20220630",
	CLOSING_STEP_1_DATE: "24/10/2021 18:00",
	CLOSING_STEP_2_DATE: "08/11/2021 10:00",
	API_PROMOCODE: "colazione-2022",
	TRACKING_PROMOCODE: "MB_raccolta_colazione_2022",
	HOLIDAYS_DATE: "02/01/2023 08:59"
}

export default Constants;
